import { render, staticRenderFns } from "./SaveStatus.vue?vue&type=template&id=33b30b6e&scoped=true"
import script from "./SaveStatus.vue?vue&type=script&lang=js"
export * from "./SaveStatus.vue?vue&type=script&lang=js"
import style0 from "./SaveStatus.vue?vue&type=style&index=0&id=33b30b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b30b6e",
  null
  
)

export default component.exports